module.exports = __webpack_public_path__ + "img/icon_check.79b7f8ce.png";